import { render } from "./PopupRendererComponent.vue?vue&type=template&id=8340bcaa&scoped=true"
import script from "./PopupRendererComponent.vue?vue&type=script&lang=js"
export * from "./PopupRendererComponent.vue?vue&type=script&lang=js"

import "./PopupRendererComponent.vue?vue&type=style&index=0&id=8340bcaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8340bcaa"]])

export default __exports__